import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken, InitPage, isRtl } from 'src/helper/tool'
import langM from './lang'
// import { VochatToFalla } from 'src/helper/domain'

import { getlang, setlang } from 'src/helper/getlang'

import Rule from './Rule'
import Share from './Share'
import Nav from './Nav'
import Nav2 from './Nav2'
import Top from './Top'
import Countdown from './Countdown'
import List from './List'
import GroupList from './GroupList'
import Copyright from './Copyright'

@inject('store')
@observer
export default class extends React.Component {

  constructor(props) {
    super(props)
    this.indiaStore = this.props.store.register('activity/ruby')
  }

  state = {
    loading: false,
    lang: langM.ar,
    nav: 1,
    nav2: 0,
    uid: '',
    rewardNav: 0,
    language:'en',
  }
  //显示隐藏rule
  hideRule = async (status) => {
    this.refs.rule.hideRule(status)
  }

  //显示隐藏Share
  hideShare = async (status) => {
    this.refs.share.hideShare(status)
    this.indiaStore.RankGift();
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    let uid = await setUidToken(this.props.location.query)
    await this.indiaStore.GetUserInfoWeb(uid)
    await this.RunOnStart(uid)
  }

  //初始化
  RunOnStart = async (uid) => {
    this.setState({ uid: uid })
    this.indiaStore.GetServerTime()
    this.indiaStore.RankGift();
    this.indiaStore.RankReward(this.state.nav, this.state.nav2);
  }

  componentDidUpdate(prevProps, prevState) {
    // 监听 `rewardNav` 的变化
    if (prevState.nav2 !== this.state.nav2 || prevState.nav !== this.state.nav) {
      this.indiaStore.RankReward(this.state.nav, this.state.nav2);
    }
  }

  componentDidMount() {
    let that = this
    setTimeout(() => {
      setDocumentTitle(that.state.lang.toptitle)
    }, 1000)
    
    //传参给store-ruby
    // this.indiaStore.RankReward(this.state.nav, this.state.rewardNav)
    // this.indiaStore.RankGift()

    // console.log(this.state.nav,this.state.nav2, 'xxxxxxxxxxxxxxxxxx');
  }

  //保存week状态
  changeNav = async (nav) => {
    console.log(nav, 'week');
    this.setState({
      nav: nav
    })
  }

  //保存发送和接受状态
  changeNav2 = async (nav) => {
    // console.log(nav, '222222222222');
    this.setState({
      nav2: nav
    })
  }

  tabContent1 = (language, list,rewardData) => {
    return (
      <div className={`tabContent1 ${this.state.nav == 0 ? 'block' : 'none'}`}>
        <div style={{ height: '0.12rem' }}></div>

        <div className={`${this.state.nav2 == 0 ? 'block' : 'none'}`}>
          <List language={language} lang={this.state.lang} list={list.world} myrank={list.worldMyrank} rewardData={rewardData}/>
        </div>
        <div className={`${this.state.nav2 == 1 ? 'block' : 'none'}`}>
          <List language={language} lang={this.state.lang} list={list.country} myrank={list.countryMyrank} rewardData={rewardData}/>
        </div>

      </div>
    )
  }

  tabContent2 = (language, list,rewardData={rewardData}) => {
    return (
      <div className={`tabContent2 ${this.state.nav == 1 ? 'block' : 'none'}`}>
        <div style={{ height: '0.12rem' }}></div>
        {/* <GroupList language={language} lang={this.state.lang} list={groupRank.world} myrank={groupRank.worldMyrank} /> */}
        {/* <div className={`${this.state.nav2 == 2 ? 'block' : 'none'}`}>
          <List language={language} lang={this.state.lang} list={list.country} myrank={list.countryMyrank} />
        </div> */}

        <div className={`${this.state.nav2 == 0 ? 'block' : 'none'}`}>
          <List language={language} lang={this.state.lang} list={list.world} myrank={list.worldMyrank} rewardData={rewardData}/>
        </div>
        <div className={`${this.state.nav2 == 1 ? 'block' : 'none'}`}>
          <List language={language} lang={this.state.lang} list={list.country} myrank={list.countryMyrank} rewardData={rewardData}/>
        </div>
      </div>
    )
  }

  // tabContent3 = (language) => {
  //   return (  
  //     <div className={`tabContent3 ${this.state.nav == 3 ? 'block' : 'none'}`}>
  //       {/* <div style={{ height: '1rem' }}></div> */}
  //       <Prize language={language} lang={this.state.lang} nav2={this.state.nav2} />
  //     </div> 
  //   )
  // }

  render() {
    let { language } = this.state
    let { remaintime, rankUser, rankGroup, now, giftData, rewardData,giftDataImg } = this.indiaStore.data;

    return (
      <div className={`algeria ${isRtl(language) && 'arlang'}`}>

        <Top language={language} lang={this.state.lang} giftDataImg={giftDataImg}/>
        <Countdown language={language} lang={this.state.lang} remaintime={remaintime} now={now} />  

        <div style={{ height: '0.4rem' }}></div>
        <Nav language={language} lang={this.state.lang} nav={this.state.nav} changeNav={this.changeNav.bind(this)} giftData={giftData} />

        <div style={{ height: '0.4rem' }}></div>

        {(this.state.nav == 0 || this.state.nav == 1) && (
          <Nav2
            language={language}
            lang={this.state.lang}
            nav={this.state.nav2}
            changeNav2={this.changeNav2.bind(this)}
          />
        )}

        {/* week状态切换 */}
        <div style={{ height: '0.3rem' }}></div>
        {this.tabContent1(language, rankUser,rewardData)}
        {this.tabContent2(language, rankGroup,rewardData)}

        {/* {this.tabContent3(language)} */}
        <div className="share" onClick={this.hideShare.bind(this, true)}>
          {this.state.lang.share}
        </div>
        <div className="rules" onClick={this.hideRule.bind(this, true)}>
          {this.state.lang.rule}
        </div>

        <Rule language={language} lang={this.state.lang} ref="rule" />
        
        <Share language={language} lang={this.state.lang} giftData={giftData} ref="share" />

        <Copyright language={language} lang={this.state.lang} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/ruby-monopoly/index.js